module.exports = __webpack_public_path__ + "img/I34-iraq.1000685e.png";